import { render } from "./BbBidOverview.vue?vue&type=template&id=fbf4b4aa&scoped=true"
import script from "./BbBidOverview.vue?vue&type=script&lang=js"
export * from "./BbBidOverview.vue?vue&type=script&lang=js"

import "./BbBidOverview.vue?vue&type=style&index=0&id=fbf4b4aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbf4b4aa"]])

export default __exports__